import { render } from "./TransitionY.vue?vue&type=template&id=3bd6b73f"
const script = {}

import "./TransitionY.vue?vue&type=style&index=0&id=3bd6b73f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__